// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".inline-list[data-v-21f212dc]{display:flex;flex-wrap:wrap;justify-content:center}.inline-list li[data-v-21f212dc]{padding-bottom:0}.inline-list li .tag-label[data-v-21f212dc]{margin-bottom:.5rem;margin-right:.5rem;text-overflow:ellipsis}@media screen and (max-width:32em){.inline-list[data-v-21f212dc]{margin:0 1rem}.inline-list li .tag-label[data-v-21f212dc]{max-width:calc(100vw - 2rem);white-space:inherit;word-wrap:break-word}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
